import useEditChart from "./useEditChart";
import EditChartComponent from "./EditChart";

const EditChart: React.FC = () => {
  const editChartProps = useEditChart();

  return EditChartComponent({
    ...editChartProps
  });
};

export default EditChart;
